import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnDestroy, OnInit, Output, Renderer2, DOCUMENT, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DialogType } from '../../../enums/dialog-type.enum';

@Component({
    standalone: false,
    selector: 'por-app-confirm-dialog',
    templateUrl: './confirm-dialog.component.html',
    styleUrls: ['./confirm-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ConfirmDialogComponent implements OnInit, OnDestroy {
    private readonly translate = inject(TranslateService);
    private readonly renderer2 = inject(Renderer2);
    private readonly document = inject<Document>(DOCUMENT);

    dialogTypeEnum = DialogType;
    @Input() dialogType: DialogType = DialogType.information;
    @Input() message: string = this.translate.instant('Are you sure?');
    @Input() externalClass?: string;
    @Output() readonly confirmed = new EventEmitter<boolean>();

    ngOnInit(): void {
        const elements = this.document.querySelectorAll('#apx.customer-portal-wrappper-cp');
        if (elements.length > 0) {
            this.renderer2.addClass(elements[0], 'dialog-backdrop');
        }
    }
    ngOnDestroy(): void {
        const elements = this.document.querySelectorAll('#apx.customer-portal-wrappper-cp');
        if (elements.length > 0) {
            this.renderer2.removeClass(elements[0], 'dialog-backdrop');
        }
    }
    sendPrompt(answer: boolean) {
        this.confirmed.emit(answer);
    }
}
